import { ParsedQuery } from 'query-string';

export interface IUrlParameter {
  name: string;
  value: string | undefined;
}

/* Helpers for Axios */
export default class ApiHelper {
  static redirect(url: string): void {
    window.location.replace(url);
  }

  static buildUrl(baseUrl: string, parameters?: IUrlParameter[]): string {
    if (!parameters) {
      return baseUrl;
    }

    const filtered = parameters
      .filter((parameter) => parameter.value !== undefined)
      .map((parameter) => `${parameter.name}=${parameter.value as string}`);
    // .map(parameter => `${parameter.name}=${encodeURIComponent(parameter.value as string)}`);

    const url = filtered && filtered.length > 0 ? `${baseUrl}?${filtered.join('&')}` : baseUrl;

    return url;
  }

  static getFullUrl(apiPath: string): string {
    return ApiHelper.getDomainUrl('api') + apiPath;
  }

  static redirectToExternal(
    returnUrl: string,
    returnData: Record<string, string | number | boolean> | ParsedQuery<string>,
    source: 'app' | 'other' = 'other',
  ): void {
    if (source === 'app') {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(returnData));
      } else {
        // eslint-disable-next-line no-console
        console.error('Only works in a react-native-webview', returnData);
      }
    } else {
      const authData = [
        {
          name: 'error',
          value: '0',
        },
        {
          name: 'data',
          value: encodeURIComponent(returnData.data as string),
        },
        {
          name: 'iv',
          value: encodeURIComponent(returnData.iv as string),
        },
      ];

      const url = ApiHelper.buildUrl(returnUrl, authData);
      ApiHelper.redirect(url);
    }
  }

  static redirectToMyAtiQxID(returnData?: Record<string, string | number | boolean> | ParsedQuery<string>): void {
    const webUri = ApiHelper.getDomainUrl('web');
    let authData: IUrlParameter[] = [];

    if (returnData) {
      authData = [
        {
          name: 'error',
          value: '0',
        },
        {
          name: 'data',
          value: encodeURIComponent(returnData.data as string),
        },
        {
          name: 'iv',
          value: encodeURIComponent(returnData.iv as string),
        },
      ];
    }

    if (webUri) {
      const url = ApiHelper.buildUrl(webUri, authData);
      ApiHelper.redirect(url);
    } else {
      // eslint-disable-next-line no-console
      console.error('No Web URI in .env file!');
    }
  }

  /** Make Url, keep http or https and add trailing slash if needed */
  static getDomainUrl(destination: 'web' | 'api'): string {
    const protocol = window.location.protocol;
    const isSSL = protocol === 'https:';
    let url = '';

    if (destination === 'web') {
      url = `${protocol}//${isSSL ? process.env.REACT_APP_WEB_URI_SSL : process.env.REACT_APP_WEB_URI}`;
    } else {
      url = `${protocol}//${isSSL ? process.env.REACT_APP_API_URI_SSL : process.env.REACT_APP_API_URI}`;
    }

    if (!url.endsWith('/')) {
      url = url + '/';
    }

    return url;
  }
}
